module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['cc-summary-outer', {
      collapsed: _vm.collapsed
    }]
  }, [_c('div', {
    staticClass: "cc-summary-pane"
  }, [_c('div', {
    staticClass: "cc-sp-collapse-btn",
    attrs: {
      "title": _vm.collapsed ? 'Expand panel' : 'Collapse panel'
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.collapsed ? '▶' : '◀') + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-collapsed-strip"
  }, _vm._l((_vm.sectionLabels), function(label, i) {
    return _c('div', {
      key: 'icon-' + i,
      class: ['cc-sp-icon', _vm.stepStatus(i + 1)],
      attrs: {
        "title": (label + ": " + (_vm.stepStatus(i + 1)))
      }
    }, [_vm._v("\n        " + _vm._s(i + 1) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-main-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(1)]
  }, [_vm._v("1")]), _vm._v(" Campaign Type")]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Type")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.type || 'Not selected yet'))])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(2)]
  }, [_vm._v("2")]), _vm._v(" " + _vm._s(_vm.audienceSectionLabel))]), _vm._v(" "), (_vm.summary.country) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Country")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.country))])]) : _vm._e(), _vm._v(" "), (_vm.summary.customer) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Customer")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.customer))])]) : _vm._e(), _vm._v(" "), (_vm.summary.journey) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Journey")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.journey))])]) : _vm._e(), _vm._v(" "), (_vm.summary.channels && _vm.summary.channels.length) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Channel")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.channels.join(', ')))])]) : _vm._e(), _vm._v(" "), (_vm.summary.languages && _vm.summary.languages.length) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Language")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.languages.join(', ')))])]) : _vm._e(), _vm._v(" "), (_vm.summary.trigger) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v(_vm._s(_vm.summary.hideSendWindow ? 'Trigger' : 'Audience'))]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.trigger))])]) : _vm._e(), _vm._v(" "), (!_vm.summary.country && !_vm.summary.customer && !_vm.summary.journey && !(_vm.summary.channels && _vm.summary.channels.length)) ? _c('div', {
    staticClass: "cc-sp-empty"
  }, [_vm._v("Not configured yet")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(3)]
  }, [_vm._v("3")]), _vm._v(" Content")]), _vm._v(" "), (_vm.summary.contentReady) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Status")]), _c('span', {
    staticClass: "cc-sp-v",
    staticStyle: {
      "color": "#2E7D32"
    }
  }, [_vm._v("✓ Generated")])]) : _c('div', {
    staticClass: "cc-sp-empty"
  }, [_vm._v("Not configured yet")])]), _vm._v(" "), (!_vm.summary.hideSendWindow) ? _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(4)]
  }, [_vm._v("4")]), _vm._v(" Send Window")]), _vm._v(" "), (_vm.summary.sendWindow) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Window")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.sendWindow))])]) : _c('div', {
    staticClass: "cc-sp-empty"
  }, [_vm._v("Not configured yet")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(_vm.guardrailStepNumber)]
  }, [_vm._v(_vm._s(_vm.guardrailStepNumber))]), _vm._v(" Guardrail Checks")]), _vm._v(" "), _vm._l((_vm.guardrailChecks), function(check) {
    return _c('div', {
      key: check,
      staticClass: "cc-sp-check"
    }, [_c('span', [_vm._v(_vm._s(_vm.summary.guardrailsPassed ? '✓' : '○'))]), _c('span', {
      class: ['cc-sp-check-text', {
        pass: _vm.summary.guardrailsPassed
      }]
    }, [_vm._v(_vm._s(check))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-footer"
  }, [_c('button', {
    staticClass: "cc-sp-schedule-btn",
    attrs: {
      "disabled": !_vm.summary.guardrailsPassed
    }
  }, [_vm._v(_vm._s(_vm.summary.finishLabel || 'Schedule Campaign'))]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-footer-hint"
  }, [_vm._v("Complete all steps to " + _vm._s(_vm.summary.hideSendWindow ? 'activate' : 'schedule'))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cc-sp-hdr"
  }, [_c('div', {
    staticClass: "cc-sp-title"
  }, [_vm._v("Campaign Summary")]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-badge"
  }, [_vm._v("In progress")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5b16e2f0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/create-campaign/summary-sidebar/CampaignSummarySidebar.vue
// module id = 7sOW
// module chunks = 1